import dayjs from "dayjs";
import isTommorow from "dayjs/plugin/isTomorrow";
import isToday from "dayjs/plugin/isToday";
import i18next from "i18next";

import {
  COMPETITOR1,
  COMPETITOR2,
  Disable12Translation,
  FEEDPROVIDER,
  ODD_TO_TEAMNAME_MARKETID,
  oddsFormats
} from "./constants";
import { SPORTBOOK_ROUTES } from "./routes";
import { ODDS_DATA } from "./odds.translation";
import { isValidNumber } from "./functions/validation.function";

const pako = require("pako");
export const getBetData = ({
  providerOutcomeId,
  specialBetValue,
  variant,
  market,
  match,
  selectedSportId,
  homeTeamId,
  awayTeamId,
  feedProvider
}) => {
  if (!market || !market?.outcomes || !market?.outcomes?.length) return;

  let odd = market?.outcomes.filter((outcome) =>
    isBetEqualToOutcome(
      { providerOutcomeId, specialBetValue, variant, feedProvider },
      outcome
    )
  );

  const marketData = { ...market, outcomes: null };
  if (marketData && Object.keys(marketData)?.length) {
    delete marketData?.outcomes;
  }
  let betData = {
    countryId: match?.countryId,
    sportId: match?.sportId,
    selectedSportId: selectedSportId,
    providerMatchId: match?.providerMatchId,
    outcomeType: odd[0],
    tournament: match?.tournament?.tournamentName,
    tournamentId: match?.tournamentId,
    odds: odd[0]?.odd,
    outcomeId: odd[0]?.outcomeId,
    providerOutcomeId: odd[0]?.providerOutcomeId,
    betStatus: match?.betStatus,
    marketId: market?.marketId,
    market: marketData,
    matchId: match?.matchId,
    matchMarketId: market?.matchMarketId,
    teams: match?.teams,
    homeTeamId,
    awayTeamId,
    isLive: match?.isLive,
    countryName: match?.country?.countryName,
    specialBetValue: odd[0]?.specialBetValue,
    variant: odd[0]?.variant,
    matchDate: match?.matchDate,
    stake: 0,
    providerMarketId: market?.market?.[0]?.providerMarketId,
    feedProvider,
    subTypeId: market?.market?.[0]?.subTypeId,
    matchTime: match?.matchTime,
    status: match?.status,
    matchScoreResult: match?.matchScoreResult.map((score) => ({
      type: score?.type,
      score: score?.score
    }))
  };

  return betData;
};

export function getName(obj, language) {
  if (!obj) return "";
  const extractName = obj?.[language]
    ? obj?.[language]
    : obj?.["en"] || obj?.["BET"];

  if (extractName && extractName?.includes("&amp;")) {
    return extractName?.replace("&amp;", "&");
  }
  return extractName || "";
}

export function oddsConverter(value, oddType) {
  if (!value || value === "-") return "-";
  if (oddType === oddsFormats[0]) return parseFloat(value).toFixed(2);
  if (oddType === oddsFormats[2])
    return `${parseFloat(value - 1).toFixed(2)}/1`;

  let val = value.toString();
  let dotIndex = val.indexOf(".");
  let roundedValue;
  if (dotIndex >= 0) {
    if (dotIndex === val.length - 2) {
      roundedValue = val + "0";
    } else {
      roundedValue = val.slice(0, dotIndex + 3);
    }
  } else {
    roundedValue = val + ".00";
  }

  if (oddType === oddsFormats[1]) {
    roundedValue = parseFloat(roundedValue);
    if (roundedValue >= 2) {
      roundedValue = (roundedValue - 1) * 100;
    }
    if (value < 2) {
      roundedValue = -100 / (roundedValue - 1);
    }
    roundedValue = roundedValue.toFixed(0);
  }
  return roundedValue;
}

export function getTeamId(teams, extarctTeamType) {
  return teams?.[extarctTeamType]?.id;
}

export function getProviderTeamId(teams, extarctTeamType) {
  if (!teams || !teams?.[extarctTeamType]) {
    return "";
  }
  if (teams?.[extarctTeamType]) {
    return teams?.[extarctTeamType]?.providerId;
  }
  return "";
}

export function getTeamName(teams, extarctTeamType, language) {
  if (!teams || !teams?.[extarctTeamType]) {
    return "";
  }
  if (teams?.[extarctTeamType]) {
    const teamNameData = teams?.[extarctTeamType];

    if (teamNameData?.name) {
      return (
        getName(teamNameData.name, language) ||
        getName(teamNameData.name, "BET") ||
        getName(teamNameData.name, "en")
      );
    }
  }
  return "";
}

let customOddsOrder = [
  "{$competitor1} ({-hcp})",
  "{$competitor1} ({+hcp})",
  COMPETITOR1,
  "{$competitor1} ({hcp})",
  "1",
  "draw",
  "x",
  "draw ({hcp})",
  COMPETITOR2,
  "{$competitor2} ({hcp})",
  "{$competitor2} ({+hcp})",
  "{$competitor2} ({-hcp})",
  "2",
  "over {total}",
  "o",
  "over",
  "under {total}",
  "u",
  "under"
];
const covertOutcome = ({
  copyMarket,
  isThreeOutcomeEqual,
  isTwoOutcomeEqual
}) => {
  if (isThreeOutcomeEqual) {
    const combineSliceOutcomes = [];
    for (let i = 0; i < copyMarket?.outcomes?.length; i = i + 3) {
      const slicedOutcome = copyMarket?.outcomes.slice(i, i + 3);
      slicedOutcome?.sort((a, b) => {
        return (
          customOddsOrder.indexOf(`${a.type}`) -
          customOddsOrder.indexOf(`${b.type}`)
        );
      });
      combineSliceOutcomes.push(...slicedOutcome);
    }
    copyMarket.outcomes = combineSliceOutcomes;
    return copyMarket;
  }
  if (isTwoOutcomeEqual) {
    const combineSliceOutcomes = [];
    for (let i = 0; i < copyMarket?.outcomes?.length; i = i + 2) {
      const slicedOutcome = copyMarket?.outcomes.slice(i, i + 2);
      slicedOutcome?.sort((a, b) => {
        return (
          customOddsOrder.indexOf(`${a.type}`) -
          customOddsOrder.indexOf(`${b.type}`)
        );
      });
      combineSliceOutcomes.push(...slicedOutcome);
    }
    copyMarket.outcomes = combineSliceOutcomes;
    return copyMarket;
  }
};
export function getMarketsByOrder(match, onlySorting = false, onlyFirst) {
  if (!match) return null;
  const markets = onlyFirst
    ? match?.matchMarkets?.slice(0, 1)
    : match?.matchMarkets?.slice(0);
  let copyMarkets = markets?.map((market) => {
    let copyMarket = {
      ...market,
      outcomes: market?.outcomes?.slice(0)
    };
    if (
      `${copyMarket?.outcomes?.[0]?.specialBetValue}` &&
      !copyMarket?.outcomes?.every(
        (outcome) =>
          outcome.specialBetValue === copyMarket?.outcomes?.[0]?.specialBetValue
      )
    ) {
      const isThreeOutcomeEqual =
        copyMarket?.outcomes?.[0]?.specialBetValue ===
          copyMarket?.outcomes?.[1]?.specialBetValue &&
        copyMarket?.outcomes?.[0]?.specialBetValue ===
          copyMarket?.outcomes?.[2]?.specialBetValue;
      const isTwoOutcomeEqual =
        copyMarket?.outcomes?.[0]?.specialBetValue ===
        copyMarket?.outcomes?.[1]?.specialBetValue;

      if (
        copyMarket?.outcomes?.length >= 3 &&
        (isThreeOutcomeEqual || isTwoOutcomeEqual)
      ) {
        return covertOutcome({
          copyMarket,
          isThreeOutcomeEqual,
          isTwoOutcomeEqual
        });
      }
      return copyMarket;
    } else {
      if (
        copyMarket?.outcomes.every((outcome) => {
          return customOddsOrder.includes(outcome.type);
        })
      ) {
        copyMarket?.outcomes?.sort((a, b) => {
          return (
            customOddsOrder.indexOf(`${a.type}`) -
            customOddsOrder.indexOf(`${b.type}`)
          );
        });
        return copyMarket;
      } else {
        copyMarket?.outcomes?.sort((a, b) => {
          if (parseInt(a.providerOutcomeId) > parseInt(b.providerOutcomeId))
            return 0;
          else if (
            parseInt(a.providerOutcomeId) < parseInt(b.providerOutcomeId)
          )
            return -1;
          else return 1;
        });
        return copyMarket;
      }
    }
  });
  if (onlySorting) return copyMarkets;
  const marketList = [];
  if (!copyMarkets?.length) return [];
  const marketOutcomes = copyMarkets?.[0]?.outcomes;
  if (
    (marketOutcomes?.[0]?.specialBetValue &&
      `${marketOutcomes?.[0]?.specialBetValue}`) ||
    (marketOutcomes?.[0]?.variant && `${marketOutcomes?.[0]?.variant}`) ||
    marketOutcomes?.length > 3
  ) {
    const firstMarketOutcomes = marketOutcomes.slice(0, 2);
    const firstMarketRemainOutcomes = marketOutcomes.slice(
      2,
      marketOutcomes?.length
    );
    marketList.push({
      ...copyMarkets?.[0],
      outcomes: firstMarketOutcomes
    });
    if (marketOutcomes?.length > 2)
      marketList.push({
        ...copyMarkets?.[0],
        outcomes: firstMarketRemainOutcomes
      });
    marketList.push(...copyMarkets.slice(1));
    return marketList;
  } else {
    return copyMarkets;
  }
}

export function replaceCompetitor(str) {
  if (!str) return "";
  else str = `${str}`;
  return str
    ?.replaceAll(COMPETITOR1, "1")
    ?.replaceAll(COMPETITOR2, "2")
    ?.replaceAll("&amp;", "&")
    ?.replaceAll("amp;", "");
}

export function replaceOnlyCompetitorWithTeam(str, homeTeam, awayTeam) {
  if (!str) return "";
  else str = `${str}`;
  return str
    ?.replaceAll(COMPETITOR1, homeTeam)
    ?.replaceAll(COMPETITOR2, awayTeam)
    ?.replaceAll("&amp;", "&")
    ?.replaceAll("amp;", "");
}

function replaceCompetitorWithTeam(
  input,
  homeTeam,
  awayTeam,
  providerMarketId,
  subTypeId,
  isLive
) {
  const isTransEnable = Disable12Translation[isLive ? "LIVE" : "PRE"]?.includes(
    providerMarketId && subTypeId
      ? providerMarketId + "_" + subTypeId
      : providerMarketId + "_"
  );
  if (compareInString(input, "1") && !isTransEnable) {
    return homeTeam;
  } else if (compareInString(input, "2") && !isTransEnable) {
    return awayTeam;
  }

  const replacedStr = input
    .replace(/\{\$competitor1\}/g, homeTeam)
    .replace(/\{\$competitor2\}/g, awayTeam);

  return replacedStr;
}

export const outcomeTypeFormatter = ({
  outcome,
  homeTeamName,
  awayTeamName,
  providerMarketId,
  feedProvider,
  language,
  subTypeId
}) => {
  let specialBetValue = outcome?.specialBetValue;
  if (
    isValidNumber(outcome?.specialBetValue) &&
    parseFloat(specialBetValue) < 0
  ) {
    specialBetValue = parseFloat(specialBetValue) * -1;
  }

  const outcomeData = ODDS_DATA[outcome?.type?.toLowerCase()];
  let oddType = outcomeData
    ? `${outcomeData?.[language] ? outcomeData?.[language] : outcome?.type}`
    : outcome?.type;
  if (!outcome || !oddType) return "";
  if (
    compareInString(FEEDPROVIDER.ESPORT, feedProvider) &&
    homeTeamName &&
    (compareInString(oddType, "1") || compareInString(oddType, COMPETITOR1))
  ) {
    let specialBetValue = outcome?.specialBetValue
      ? outcome?.specialBetValue
      : "";

    return specialBetValue
      ? `${homeTeamName} (${specialBetValue})`
      : `${homeTeamName}`;
  }

  if (
    compareInString(FEEDPROVIDER.ESPORT, feedProvider) &&
    awayTeamName &&
    (compareInString(oddType, "2") || compareInString(oddType, COMPETITOR2))
  ) {
    let specialBetValue = outcome?.specialBetValue
      ? outcome?.specialBetValue
      : "";

    return specialBetValue
      ? `${awayTeamName} (${specialBetValue})`
      : `${awayTeamName}`;
  }

  let outcomeType = "";
  let formattedOutComeType = outcome && replaceCompetitor(oddType);
  const marketAndSubTypeId = outcome?.isLive
    ? providerMarketId + "_" + (subTypeId ? subTypeId : "")
    : providerMarketId;
  if (
    ODD_TO_TEAMNAME_MARKETID[outcome?.isLive ? "live" : "preLive"]?.filter(
      (id) => compareInString(marketAndSubTypeId, id)
    )?.length
  ) {
    if (homeTeamName && awayTeamName) {
      formattedOutComeType = replaceCompetitorWithTeam(
        oddType,
        homeTeamName,
        awayTeamName,
        providerMarketId,
        subTypeId,
        outcome?.isLive
      );
    }
  }

  let matchFromOutcomeType =
    outcome && formattedOutComeType?.match(/\{[^}]*\b([a-zA-Z]+)\b[^}]*\}/);
  if (
    outcome &&
    outcome?.specialBetValue &&
    matchFromOutcomeType &&
    matchFromOutcomeType?.length > 1
  ) {
    //for ex : "over {total}"
    outcomeType = formattedOutComeType?.replace(
      `${matchFromOutcomeType?.[1]}`,
      `(${specialBetValue})`
    );
  } else {
    if (outcome?.specialBetValue && formattedOutComeType) {
      outcomeType = `${formattedOutComeType} (${outcome?.specialBetValue})`;
    } else outcomeType = formattedOutComeType;
  }

  return outcomeType
    ?.replace("{", "")
    ?.replace("}", "")
    ?.replace("((", "(")
    ?.replace("))", ")")
    ?.replace("(+(", "(+")
    ?.replace("(-(", "(-");
};

export function getMarketColumn(market) {
  const pattern = /\b(?:[ou]|over|under|Over|Under)\b/;
  if (market?.outcomes?.length && pattern.test(market?.outcomes?.[0]?.type)) {
    return 6;
  }
  if (
    market?.outcomes?.length === 2 ||
    market?.outcomes?.[0]?.specialBetValue ||
    `${market?.outcomes?.[0]?.specialBetValue}` ||
    market?.outcomes?.[0]?.variant ||
    `${market?.outcomes?.[0]?.variant}`
  ) {
    if (market?.outcomes?.length === 3) {
      return 4;
    }
    if (
      market?.outcomes?.length >= 3 &&
      market?.outcomes?.[0]?.specialBetValue ===
        market?.outcomes?.[1]?.specialBetValue &&
      market?.outcomes?.[0]?.specialBetValue ===
        market?.outcomes?.[2]?.specialBetValue
    ) {
      return 4;
    }
    return 6;
  } else {
    return 4;
  }
}
export let codec = null;
export const decodeSocketData = (value) => {
  try {
    if (value?.length > 1) {
      const parseData = pako.inflate(value?.[1], { to: "string" });
      const result = JSON.parse(parseData);
      return result;
    }
  } catch (err) {
    console.log(err);
  }
};
export const getUpdatedMarketData = (
  previousMatchmarketObj,
  newMatchMarket,
  betStatus
) => {
  let markets = { ...previousMatchmarketObj };
  if (!newMatchMarket || !newMatchMarket?.length) return previousMatchmarketObj;
  if (previousMatchmarketObj) {
    for (let i = 0; i < newMatchMarket.length; i++) {
      const marketWithNewData = newMatchMarket?.[i];
      if (previousMatchmarketObj?.[marketWithNewData?.matchMarketId]) {
        const marketWithPrevDataCopy = {
          ...previousMatchmarketObj?.[marketWithNewData?.matchMarketId]
        };
        const prevMarketPrevoutcomesCopy = [
          ...(marketWithPrevDataCopy.outcomes || [])
        ];

        if (marketWithPrevDataCopy && marketWithNewData?.outcomes) {
          marketWithNewData?.outcomes?.forEach((outcome) => {
            const findOutcomeIndex = prevMarketPrevoutcomesCopy?.findIndex(
              (outcomeData) => isBetEqualToOutcome(outcomeData, outcome)
            );
            const foundOutcomeData =
              prevMarketPrevoutcomesCopy?.[findOutcomeIndex];
            if (findOutcomeIndex !== -1) {
              if (isOutcomeValid(outcome, betStatus)) {
                if (
                  !(
                    compareInString(
                      foundOutcomeData?.active,
                      outcome?.active
                    ) &&
                    compareInString(foundOutcomeData?.odd, outcome?.odd) &&
                    compareInString(foundOutcomeData?.type, outcome?.type)
                  )
                ) {
                  prevMarketPrevoutcomesCopy[findOutcomeIndex] = {
                    ...foundOutcomeData,
                    ...outcome,
                    isSocketUpdated: true
                  };
                }
              } else {
                if (!marketWithPrevDataCopy?.market?.[0]?.isStaticMarket) {
                  prevMarketPrevoutcomesCopy?.splice(findOutcomeIndex, 1);
                }
              }
            } else {
              if (isOutcomeValid(outcome, betStatus))
                prevMarketPrevoutcomesCopy.push(outcome);
            }
          });
          marketWithPrevDataCopy["outcomes"] = prevMarketPrevoutcomesCopy;

          markets[marketWithNewData?.matchMarketId] = marketWithPrevDataCopy;
        }
      }
    }
    return markets;
  }
};

export function compareInString(args1, args2) {
  return `${args1}` === `${args2}`;
}

export const getMatchTime = (matchTime = "") => {
  if (!matchTime) {
    return {
      matchDate: "",
      dayString: ""
    };
  }
  dayjs.extend(isTommorow);
  dayjs.extend(isToday);
  const todaysDate = dayjs().startOf("D");
  const matchDate = dayjs(matchTime);
  const days = matchDate.diff(todaysDate, "day");

  let dayString = "";
  if (matchDate.isToday()) {
    dayString = i18next.t("SCHEDULE.TODAY");
  } else if (matchDate.isTomorrow()) {
    dayString = i18next.t("SCHEDULE.TOMMOROW");
  } else if (days < 3) {
    dayString = `In ${days} days`;
  } else {
    dayString = matchDate.format("MMM	D");
  }
  return {
    matchDate: matchDate.format("HH:mm"),
    dayString
  };
};

export function getMarketName(
  homeTeamName,
  awayTeamName,
  marketData,
  language,
  feedProvider
) {
  const market = {
    ...marketData?.market?.[0],
    outcomes: marketData?.outcomes
  };

  if (!market?.marketName) return "";
  //   const regex12 = /\b1\b|\b2\b/g;

  let marketName = replaceOnlyCompetitorWithTeam(
    getName(market?.marketName, language),
    homeTeamName,
    awayTeamName
  );

  //   if (homeTeamName && awayTeamName)
  //     marketName = marketName.replace(regex12, (match) =>
  //       compareInString(match, "1") ? homeTeamName : awayTeamName
  //     );

  let regex = /\{([^}]+)\}/;
  let match = marketName?.match(regex);
  let matchedContent = match?.length > 1 && match?.[1];

  if (
    matchedContent &&
    market?.outcomes?.every(
      ({ variant }) => variant && market?.outcomes[0]?.variant === variant
    )
  ) {
    let matchedTexts = [...marketName.matchAll(/\{([^}]+)\}/g)];

    let variant = market?.outcomes[0]?.variant;
    matchedTexts.forEach((matchedText) => {
      let matchStr = matchedText?.length > 1 && matchedText?.[1];
      if (matchStr) {
        const find = `${matchStr?.replace(/[^a-zA-Z0-9]/g, "")}=`;
        const matchedContentIndexInVariant = variant?.search(find);
        if (matchedContentIndexInVariant !== -1 && find?.length) {
          const matchStrValueInVariant = variant
            ?.slice(matchedContentIndexInVariant + find?.length)
            ?.match(/^[+-]?\d+(?::\d+)*/);

          if (matchStrValueInVariant?.length)
            marketName = marketName?.replace(
              `{${matchStr}}`,
              `${matchStrValueInVariant?.[0]}`
            );
        }
      }
    });
  } else if (
    market?.outcomes?.length &&
    market?.outcomes?.every(
      ({ variant }) => variant && market?.outcomes[0]?.variant === variant
    )
  ) {
    const variantMatch = market?.outcomes?.[0]?.variant?.match(/[+-\d]+.*/g);
    if (variantMatch) marketName = `${marketName} ${variantMatch}`;
  } else if (
    market?.outcomes?.length &&
    market?.outcomes?.every(
      (outcome) =>
        outcome?.specialBetValue &&
        market?.outcomes[0]?.specialBetValue === outcome?.specialBetValue
    ) &&
    matchedContent
  ) {
    marketName = marketName?.replace(
      `{${matchedContent}}`,
      `(${market?.outcomes[0]?.specialBetValue})`
    );
  } else {
    if (matchedContent) {
      marketName = marketName?.replace(`{${matchedContent}}`, "");
    }
  }

  return marketName;
}

export function getErrorMessageObj(error) {
  if (error?.message) {
    return {
      error: error?.message || ""
    };
  }
  if (error?.data?.message)
    return {
      error: error?.data?.message || ""
    };
  if (typeof error?.data?.errorMsg === "string") {
    return { error: error?.data?.errorMsg };
  }

  if (typeof error?.data?.errorMsg === "object") {
    if (Object.values(error?.data?.errorMsg)?.length) {
      return { error: Object.values(error?.data?.errorMsg)?.[0] };
    }
  }

  return { error: "" };
}

export const loadState = (key) => {
  try {
    const serializedState = localStorage.getItem(key);
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (err) {
    return undefined;
  }
};

export const saveState = (state) => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem("statesportbook", serializedState);
  } catch (err) {
    console.log(err);
  }
};

export const isOutcomeValid = (outcome, betStatus) => {
  return (
    outcome?.type &&
    outcome?.odd &&
    !compareInString(outcome?.type, "-1") &&
    outcome.active &&
    compareInString(betStatus, "1")
  );
};

export const isBetEqualToOutcome = (bet, outcome) => {
  return (
    compareInString(bet?.providerOutcomeId, outcome?.providerOutcomeId) &&
    compareInString(bet?.specialBetValue, outcome?.specialBetValue) &&
    compareInString(bet?.variant, outcome?.variant) &&
    compareInString(bet?.feedProvider, outcome?.feedProvider)
  );
};

export const joinRooms = ({
  matches,
  liveSocket,
  preLiveSocket,
  liveEvent,
  preLiveEvent,
  isReconnect,
  isReconnectLive
}) => {
  if (matches?.length) {
    const livematches = matches.filter((match) => match.isLive);
    const preLivematches = matches.filter((match) => !match.isLive);
    const liveEventNames = livematches.map((match) => {
      const matchRoomId = `${match?.sportId}${match?.tournamentId}${match?.matchId}`;
      const eventName = match?.isLive
        ? `${liveEvent}/${matchRoomId}`
        : `${preLiveEvent}/${matchRoomId}`;
      return eventName;
    });

    const preLiveEventNames = preLivematches.map((match) => {
      const matchRoomId = `${match?.sportId}${match?.tournamentId}${match?.matchId}`;
      const eventName = match?.isLive
        ? `${liveEvent}/${matchRoomId}`
        : `${preLiveEvent}/${matchRoomId}`;
      return eventName;
    });
    if (!isReconnect) {
      liveEventNames?.length && liveSocket.emit("joinroom", liveEventNames);
      preLiveEventNames?.length &&
        preLiveSocket.emit("joinroom", preLiveEventNames);
    } else {
      liveEventNames?.length &&
        isReconnectLive &&
        liveSocket.emit("joinroom", liveEventNames);
      preLiveEventNames?.length &&
        !isReconnectLive &&
        preLiveSocket.emit("joinroom", preLiveEventNames);
    }
  }
};

export const leaveRooms = ({
  matches,
  liveSocket,
  preLiveSocket,
  liveEvent,
  preLiveEvent
}) => {
  if (matches.length) {
    const livematches = matches.filter((match) => match.isLive);
    const preLivematches = matches.filter((match) => !match.isLive);
    const liveEventNames = livematches.map((match) => {
      const matchRoomId = `${match.sportId}${match.tournamentId}${match.matchId}`;
      const eventName = match.isLive
        ? `${liveEvent}/${matchRoomId}`
        : `${preLiveEvent}/${matchRoomId}`;
      return eventName;
    });

    const preLiveEventNames = preLivematches.map((match) => {
      const matchRoomId = `${match.sportId}${match.tournamentId}${match.matchId}`;
      const eventName = match.isLive
        ? `${liveEvent}/${matchRoomId}`
        : `${preLiveEvent}/${matchRoomId}`;
      return eventName;
    });
    liveEventNames?.length && liveSocket.emit("leaveroom", liveEventNames);
    preLiveEventNames?.length &&
      preLiveSocket.emit("leaveroom", preLiveEventNames);
  }
};

export const isNotSportPage = (path) => {
  if (Object.values(SPORTBOOK_ROUTES).includes(path)) {
    return true;
  }
  return false;
};

export function getTeamImage(teams, extarctTeamType) {
  if (!teams || !teams?.length) {
    return "";
  }
  if (teams?.length) {
    let providerTeamimageData = teams?.filter(
      (team) => team?.type === extarctTeamType
    );
    if (providerTeamimageData?.length) {
      return providerTeamimageData?.[0]?.team?.imageUrl;
    }
  }
  return "";
}
